import { render } from "./EditChannelMaintenance.vue?vue&type=template&id=8466dc10"
import script from "./EditChannelMaintenance.vue?vue&type=script&lang=js"
export * from "./EditChannelMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__